import { sendGTMEvent } from './gtm-helper';

export const sendPlayGameEvent = () => {
  sendGTMEvent({
    category: 'WebGL Game',
    event: 'webgl_game_start',
    action: 'webgl-game-start/clicked',
  });
};

export const sendGameExitEvent = () => {
  sendGTMEvent({
    category: 'WebGL Game',
    event: 'webgl_game_exit_confirm_button_clicked',
    action: 'webgl-game-exit/confirmed',
  });
};
